import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';
import { TranslatePipe } from '@ngx-translate/core';
import { QRCodeComponent } from 'angularx-qrcode';

export interface DialogInviteGroupData {
  link: string;
}

@Component({
  selector: 'app-dialog-invite-group',
  imports: [MatDialogModule, TranslatePipe, QRCodeComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dialog-invite-group.component.html',
  styleUrl: './dialog-invite-group.component.scss',
})
export class DialogInviteGroupComponent {
  readonly data = inject<DialogInviteGroupData>(MAT_DIALOG_DATA);
  private readonly clipboard = inject(Clipboard);

  readonly copied = signal(false);

  copyLink(): void {
    this.clipboard.copy(this.data.link);
    this.copied.set(true);
  }
}
